import styled from "@emotion/styled"
import { FlexContainer } from "../../../styled/flexbox.styled"

export const BloombergAuthContainer = styled(FlexContainer)({
  gridArea: "content",
  overflow: "auto",
  height: "100%",
})
